import {fulfilled} from 'lib/promiseMiddlewareHelpers'
import {Map, OrderedSet} from 'immutable'
import {LOAD_USER_FAVORITES} from 'lib/api/favorites'
import {Segment} from 'data/records'
import {apiv3} from 'lib/apiv3'
import {loadAllPages} from 'lib/loadAllPages'

export const LOAD_SEGMENT = 'segments/LOAD_SEGMENT'
export const LOAD_USER_CREATED_SEGMENTS = 'segments/LOAD_USER_CREATED_SEGMENTS'

const initialState = Map({
  segments: Map(), // id -> Segment
  createdSegments: OrderedSet() // ids
})

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case fulfilled(LOAD_USER_FAVORITES): {
      const segments = action.payload.extras
        .filter(f => f.type === 'segment')
        .map(f => Segment.deserialize(f.segment))
      return state.mergeIn(['segments'], segments.map(s => [s.id, s]))
    }
    case fulfilled(LOAD_USER_CREATED_SEGMENTS): {
      const newSegments = action.payload.results
        .map(f => Segment.deserialize(f))

      const segments = state.get('segments').merge(newSegments.map(s => [s.id, s]))
      const createdSegments = state.get('createdSegments').union(OrderedSet(newSegments.map(s => s.id)))

      return state.merge({
        segments: segments,
        createdSegments: createdSegments
      })
    }
    default:
      return state
  }
}

export const loadCreatedSegments = (userId, params = null) => ({
  type: LOAD_USER_CREATED_SEGMENTS,
  payload: apiv3.users.createdSegments(userId, params),
  meta: {userId}
})

export const loadAllUserCreatedSegments = (userId) => (dispatch) => {
  const loadCreatedSegmentsPage = (pageInfo) => {
    const {pageIndex, perPage} = pageInfo
    return dispatch(loadCreatedSegments(userId, {page: pageIndex, per_page: perPage, order_by: 'created_at', extras: true}))
  }

  const isLastPage = ({perPage, pageIndex, pageResults}) => {
    return perPage * (pageIndex + 1) >= pageResults.value.total_count
  }

  return loadAllPages({promiseProducer: loadCreatedSegmentsPage, perPage: 50, isLastPage})
}
